let style = getComputedStyle(document.body);

const primaryScreenSizes = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
];

export const screenSizes = [
  'min-sm',
  'min-md',
  'min-lg',
  'min-xl',
  ...primaryScreenSizes,
];

export default {
  themes: {
    DARK: 'dark',
    LIGHT: 'light',
  },
  setTheme(theme) {
    document.body.dataset.theme = theme;
    style = getComputedStyle(document.body);
  },
  getStyleVar(name) {
    return style.getPropertyValue(`--${name}`);
  },
  getFontColor() {
    return this.getStyleVar('font-color-primary');
  },
  getPrimaryColor() {
    return this.getStyleVar('color-primary');
  },
  /**
   * Retorna se o display de visualização é de um determinado tamanho no presente momento.
   *
   * Esse método lê as variáveis CSS implementadas em "src\styles\defaults\mobileFirst.sass"
   * que indicam qual é o tamanho atual da tela.
   *
   * @param {String} size Tamanhos de tela do Bootstrap.
   *   Aceita modificadores min e max conforme implementado em mobileFirst, exemplo: min-sm, max-md.
   * @returns {Boolean}
   */
  isScreenSize(size) {
    return this.getStyleVar(`screen-${size}`).trim() === 'yes';
  },
  isDarkTheme() {
    return document.body.dataset.theme === this.themes.DARK;
  },
  getCurrentScreenSize() {
    for (let i = 0; i < primaryScreenSizes.length; i += 1) {
      if (this.getStyleVar(`screen-${primaryScreenSizes[i]}`).trim() === 'yes') {
        return primaryScreenSizes[i];
      }
    }

    return '';
  },
  isSafari() {
    return navigator.vendor.match(/apple/i);
  },
};
